module.exports = __webpack_public_path__ + "static/media/title-background.2c36b4ee.png";